import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeaderWithBack from '../Components/HeaderWithBack';
import DeleteUserConfirmationModal from '../Components/DeleteUserConfirmationModal';

import Loading from '../Components/Loading';

import styles from '../Styles/Account.module.css';

const Users = () => {
    const { openTimeModal } = useTimeModal();
    const [users, setUsers] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get('/api/users', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setUsers(response.data);
                setLoading(false);
            }).catch(err => {
                setWarning('Ошибка получения данных: '+err.response.data);
                setLoading(false);
            });
        } else {
            handleLogout();
        }
        setReload(false);
    }, [reload]);

    const changeApproval = (userId) => {
        axios.put('/api/change-approval', { userId })
        .then(() => {
            openTimeModal('Доступ к системе изменен', 'success');
            setReload(true);
        })
        .catch(() => {
            openTimeModal('Ошибка изменения доступа пользователя к системе', 'error');
        });
    };

    const [isDeleteModal, setIsDeleteModal] = React.useState(false);
    const [selectedUserId, setSelectedUserId] = React.useState('');

    return (
        <>
            {isDeleteModal && <DeleteUserConfirmationModal closeModal={() => {setIsDeleteModal(false)}} userId={selectedUserId} onSuccess={() => {setReload(true)}} />}
            <div className='main'>
            <HeaderWithBack />
            <div className={styles.horizontalData}>
                <div className={styles.liningData}>
                    <h1>Пользователи</h1>
                    {loading ? <Loading />
                    : warning ? <div className={styles.line}><a>{warning}</a></div>
                    : users.map((user) => (
                        <div className={styles.line}>
                            <a style={{width: '40%'}}>{user?.lastname+' '+user?.firstname+' '+user?.surname || 'ФИО отсутствует'}</a>
                            <a style={{width: '40%'}}>{user.approval || 'Ошибка системы'}</a>
                            <a style={{width: '20%', display: 'flex', flexDirection: 'column'}}>
                                {!user.me ? user.approval=='Активен' ? 
                                <button style={{width: '100%'}} type='button' className='button' onClick={() => {changeApproval(user.id)}}>Отозвать доступ</button> 
                                : 
                                <>
                                    <button style={{width: '100%'}} type='button' className='button' onClick={() => {changeApproval(user.id)}}>Выдать доступ</button> 
                                    <button style={{width: '100%'}} type='button' className='button red' onClick={() => {setIsDeleteModal(true); setSelectedUserId(user.id)}}>Удалить аккаунт</button>
                                </>
                                : 
                                <a className='description'>В целях безопасности вы не можете отозвать у себя доступ</a>}
                            </a>
                        </div>
                    ))}
                </div>
            </div>
            </div>
        </>
    )
}

export default Users;